import React, { useCallback, useLayoutEffect, useMemo, useRef } from 'react';
import { setYear, getYear } from 'date-fns';
import { Container, Year } from './styled';
import { useDateTimePicker } from '../..';
import { isInRange } from '../../util';

const AMOUNT_OF_SELECTABLE_YEARS = 101;

export const YearSelection: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { selectedValue, setSelectedValue, minDate, maxDate, setPickerMode } =
    useDateTimePicker();

  const handleSelect = useCallback(
    (year: number) => {
      setSelectedValue(setYear(selectedValue, year));
      setPickerMode('Date');
    },
    [selectedValue, setSelectedValue, setPickerMode],
  );

  const selectedYear = useMemo(() => getYear(selectedValue), [selectedValue]);

  const years = useMemo(
    () =>
      Array.from({ length: AMOUNT_OF_SELECTABLE_YEARS }, (_, i) => {
        const year = Math.ceil(
          selectedYear - AMOUNT_OF_SELECTABLE_YEARS / 2 + i,
        );

        return {
          year,
          selected: year === selectedYear,
          disabled: !isInRange(setYear(selectedValue, year), minDate, maxDate),
        };
      }),
    [maxDate, minDate, selectedValue, selectedYear],
  );

  useLayoutEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop =
        Math.ceil(AMOUNT_OF_SELECTABLE_YEARS / 2 + 1) * 32 - 10;
    }
  }, []);

  return (
    <Container ref={containerRef}>
      {years.map((item) => (
        <Year
          selected={item.selected}
          key={item.year}
          onClick={() => handleSelect(item.year)}
          disabled={item.disabled}
          type="button"
        >
          {item.year}
        </Year>
      ))}
    </Container>
  );
};
